import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';


import { DialogService }  from 'ng2-bootstrap-modal';
import { ErrorComponent } from '../../popup/error.component';
import { AlertComponent } from '../../popup/alert.component';
import { ConfirmComponent } from '../../popup/confirm.component';
import { YesNoComponent } from 'app/popup/yesno.component';



@Injectable({
  providedIn: 'root',
})
export class PopupService{

  constructor(@Optional() public dialogService: DialogService) {}

   showError(title: string, message: string, error: any) {

    this.dialogService.addDialog(ErrorComponent, {
        title: title,
        message: message,
        statuscode: error.Status,
        url: error.Uri,
        servermessage: error.Message
    })
   }


   showAlert(title: string, message: string, bold?: string) {

    this.dialogService.addDialog(AlertComponent, {
        title: title,
        message: message,
        bold: bold
    });

   }

showConfirm(title: string, message: string, extra:string, confirmText?: string, cancelText?: string, bold?: string): Observable<boolean> {

    return this.dialogService.addDialog(ConfirmComponent, {
            title: title,
            message: message,
            extra: extra,
            confirmButtonText: confirmText,
            cancelButtonText: cancelText
    });

}

  showYesNo(title: string, message: string, comment: string, confirmText?: string, cancelText?: string): Observable<boolean> {

    return this.dialogService.addDialog(YesNoComponent, {
      title: title,
      message: message,
      comment: comment,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText
    });

  }



}
